<template>
  <div :ref="chartRefId" style="width: 100%; height: 260px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'LineChartGroupedECharts',
  props: {
    months: { type: Array, required: true },
    lastYear: { type: Array, required: true },
    present: { type: Array, required: true }
  },
  data() {
    return {
      chartRefId: `line-grouped-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },
  watch: {
    months() {
      this.updateChart();
    },
    lastYear() {
      this.updateChart();
    },
    present() {
      this.updateChart();
    }
  },
  methods: {
    initChart() {
      const el = this.$refs[this.chartRefId];
      if (!el) return;

      this.chartInstance = echarts.init(el);

      this.chartInstance.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.months,
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          max: 100,
          interval: 25,
          splitLine: {
            show: false
          },
        },
        series: [
          {
            name: 'Last Year',
            type: 'line',
            data: this.lastYear,
            smooth: true,
            lineStyle: { width: 3, color: '#ff92ae' },
            showSymbol: false
          },
          {
            name: 'Present',
            type: 'line',
            data: this.present,
            smooth: true,
            lineStyle: { width: 3, color: '#65e9f0' },
            showSymbol: false
          }
        ]
      });
    },
    updateChart() {
      if (!this.chartInstance) return;
      this.chartInstance.setOption({
        xAxis: {
          type: 'category',
          data: this.months,
          boundaryGap: false
        },
        series: [
          {
            name: 'Last Year',
            type: 'line',
            data: this.lastYear,
            smooth: true,
            lineStyle: { width: 3, color: '#ff92ae' },
            showSymbol: false
          },
          {
            name: 'Present',
            type: 'line',
            data: this.present,
            smooth: true,
            lineStyle: { width: 3, color: '#65e9f0' },
            showSymbol: false
          }
        ]
      });
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
